/* Package JSON Import will be here */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import { updateSelectedSortingFilterTemp } from "reducers/filter/attrFilter";
import SortingTemplate from "./SortingTemplate";
import Constants from "utilities/appConstants";
/* Project Import will be here */

const ProductSortingAttrFilter = (props) => {
    const { attrFilter } = useSelector((state) => ({
        attrFilter: state.attrFilter
    }));

    const dispatch = useDispatch();

    useEffect(() => {
        let initialSorting = attrFilter.selectedSortingFilterTemp;
        if (props.pageType === Constants.SALES_RETURN_ATTR) {
            if (initialSorting === Constants.PRICE_ASC || initialSorting === Constants.PRICE_DESC)
                initialSorting = Constants.NAME_ASC
        }

        dispatch(updateSelectedSortingFilterTemp(attrFilter.isFilterApplied ? initialSorting : attrFilter.selectedSortingFilter));
    }, []);

    const onChangeSortType = e => {
        dispatch(updateSelectedSortingFilterTemp(e.target.value));
    };

    const productSortTabContent = () => {
        return (
            <SortingTemplate
                onChangeSortType={onChangeSortType}
                selectedSortType={attrFilter.selectedSortingFilterTemp}
                pageType={props.pageType}
            />
        );
    }

    return (
        <React.Fragment>
            {productSortTabContent()}
        </React.Fragment>
    );
};

export default ProductSortingAttrFilter;